import React, { type PropsWithChildren } from "react";

export function Alert({ children }: PropsWithChildren<unknown>) {
  return (
    <span className="inline-flex text-sm">
      <span className="bg-[#36B7B7] rounded-s-lg flex items-center justify-center w-9">
        <i className="fa-regular fa-sharp fa-info-circle text-white" />
      </span>
      <span className="p-2 pr-3 bg-[#EDFBFB] rounded-e-lg">{children}</span>
    </span>
  );
}
